<script setup lang="ts">
import { cn } from 'cn'
import { computed } from 'vue'
import { DialogTitle, useForwardProps } from 'reka-ui'

import type { DialogTitleProps } from './types'

import { dialogTitleVariants } from './variants'

const props = withDefaults(defineProps<DialogTitleProps>(), {
  size: 'md',
})

const delegatedProps = computed(() => {
  const { class: _, size: _1, ...delegated } = props

  return delegated
})

const forwardedProps = useForwardProps(delegatedProps)
</script>

<template>
  <DialogTitle
    v-bind="forwardedProps"
    :class="
      cn(
        dialogTitleVariants({ size }),
        props.class,
      )
    "
  >
    <slot />
  </DialogTitle>
</template>
